import { render, staticRenderFns } from "./AcceptInviteRoute.vue?vue&type=template&id=a5610466"
import script from "./AcceptInviteRoute.vue?vue&type=script&lang=js"
export * from "./AcceptInviteRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports